/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Start_Signup_SubtitleInputs */



/**
* | output |
* | --- |
* | "Start the signup process for your organization" |
*
* @param {Auth_Start_Signup_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_start_signup_subtitle = /** @type {((inputs?: Auth_Start_Signup_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Start_Signup_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Starten Sie den Registrierungsprozess für Ihre Organisation")
	return /** @type {LocalizedString} */ ("Start the signup process for your organization")
});